<tdv-upload-resource-progress
  *ngIf="showProgress"
  class="block fixed bg-work-area rounded-16"
></tdv-upload-resource-progress>
